import { HTMLAttributes } from 'react';
import { CTAButtonTypes } from '../../../../components/ctaButton/CTAButtonTypes';

export namespace ImportantBenefitTypes {
  export interface IImportantBenefits extends HTMLAttributes<HTMLDivElement> {
    showImportantBenefits: boolean;
    title: string;
    description: string;
    customArt?: TCustomArt;
    sectionBackgroundColor?: 'primary' | 'secondary';
    textColor?: 'primary' | 'secondary';
    theme?: 'light' | 'dark';
    callToAction: CTAButtonTypes.TCallToAction;
  }

  export interface ICustomArt extends HTMLAttributes<HTMLDivElement> {
    imageUrl: string;
  }

  export interface ITextSection extends HTMLAttributes<HTMLDivElement> {
    title: string;
    description: string;
    textColor?: 'primary' | 'secondary';
    theme?: 'light' | 'dark';
    callToAction: CTAButtonTypes.TCallToAction;
  }

  export type TCustomArt = {
    show: boolean;
    imageUrl: string;
    position: 'left' | 'right';
  };
}
